import React, { Dispatch, SetStateAction } from "react";

import { Input, Label, RadioInput } from "../styles";

interface Data {
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => any;
  selectedOption: string;
  setSelectedOption: Dispatch<SetStateAction<string>>;
}

// MED-691: Medex is only the collection point for the licence number now —
// issue/expiry dates and the certificate upload move to PCN's own
// registration form, which PCN backend validation (and, once linked, the
// applicant's own PCN record) is what actually resolves and stores them.
function PcnIDVerification({ onChange, selectedOption, setSelectedOption }: Data) {
  return (
    <div className="pcn-container">
      <div className="input_container">
        <div className="heading">MEDEX Onboarding</div>
        <div className="sub-heading">
          <div className="stepcounter">Step 5 of 5</div>
          <div className="stepcountTitle">PCN Licence</div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "left",
          justifyItems: "start",
        }}
      >
        <div style={{ marginTop: "10px" }}>
          Do you have a PCN Licence Number?
        </div>

        <RadioInput>
          <div className="radio">
            <input
              type="radio"
              value="yes"
              name="hasPcn"
              checked={selectedOption === "yes"}
              onChange={(event) => {
                onChange(event);
                setSelectedOption(event.target.value);
              }}
            />
            <label>Yes</label>
          </div>

          <div className="radio">
            <input
              type="radio"
              value="no"
              name="hasPcn"
              checked={selectedOption === "no"}
              onChange={(event) => {
                onChange(event);
                setSelectedOption(event.target.value);
              }}
            />
            <label>No</label>
          </div>
        </RadioInput>

        {selectedOption === "yes" && (
          <div style={{ marginTop: "30px" }}>
            <Label style={{ fontSize: "0.95rem" }} htmlFor="name">
              Enter PCN Licence Number
            </Label>
            <Input
              id="name"
              name="current_pcn_licence_number"
              type="text"
              onChange={onChange}
              required
            />
            <p
              style={{
                fontSize: "0.8rem",
                color: "#667085",
                marginTop: "0.75rem",
                lineHeight: 1.5,
              }}
            >
              We'll check this against the PCN registry. If it needs
              anything further — registration, linking, or renewal — you'll
              be taken to the PCN platform to finish that next.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PcnIDVerification;
